import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import { Skip } from "../../../views/fle/Molecules"
import { BodySmall } from "../../../views/atoms/Bodies"
import useButtonSingleSelect from "../../hooks/useButtonSingleSelect"
import ButtonSelectGroup from "../../shared/ButtonSelectGroup"
import { useRoutingInfo } from "../../context/RoutingInfoContext"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"

const ViewName = Steps.PERSON_OF_COLOR_SHARE_BACKGROUND
export default function PersonOfColorShareBackgroundStep(): JSX.Element {
  const { routingData, updateRoutingInfo, hasQuestionBeenSkipped } = useRoutingInfo()
  const defaultValue = routingData?.pocPrefSameBackground
  const { setNextStep } = useStateMachine(
    ViewName,
    defaultValue || hasQuestionBeenSkipped("pocPrefSameBackground") ? "" : null
  )
  const { handleContinueLoading, continueLoading } = useJourneyFlow()
  const { valid, ...buttonProps } = useButtonSingleSelect({
    options: [
      { title: "Yes", id: "YES" },
      { title: "No", id: "NO" }
    ],
    defaultValue,
    onSubmit: onClickContinue
  })
  async function onClickContinue(selectedValue: string): Promise<void> {
    if (selectedValue !== null) {
      await handleContinueLoading(() => updateRoutingInfo({ pocPrefSameBackground: selectedValue }))
      setNextStep(ViewName, "")
    }
  }

  async function onSkip(): Promise<void> {
    await handleContinueLoading(() => updateRoutingInfo({ skipFields: ["pocPrefSameBackground"] }))
    setNextStep(ViewName, "")
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue(defaultValue)
      }}
    >
      <Container stack="large">
        <H2 stack="tiny">
          {`If you may be choosing a local provider, would you like help finding someone who shares your background?`}
        </H2>
        <BodySmall>
          {`We know how important BIPOC providers are for overcoming health disparities, and we're eager to help you find someone who will make you feel welcome and empowered.`}
        </BodySmall>
      </Container>
      <Container>
        <ButtonSelectGroup {...buttonProps} />
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="space-between">
        <Skip onClick={onSkip} onClickOnly enabled={!continueLoading} />
        <ArrowSubmitButton enabled={valid && !continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
